import React from 'react'
import ReactDOM from 'react-dom'
import ModalAlert from 'frontend/components/modal-alert'
import lozad from 'lozad'
import Glide, { Controls, Autoplay, Swipe, Breakpoints, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'
import Logger from 'lib/logger'

export default class Reviews {
  static get carouselEl () {
    return document.querySelector(`${this.rootSelector} .reviews_carousel`)
  }

  static get hasRating () {
    return !this.carouselEl.classList.contains('without_rating')
  }

  static get slidesCount () {
    return document.querySelectorAll(`${this.rootSelector} .reviews_list .review`).length
  }

  static perView (value) {
    return value > this.slidesCount ? this.slidesCount : value
  }

  static mountGlide () {
    Logger.debug('Reviews.mountGlide', this.hasRating ? 'has rating' : 'no rating')
    this.glide = new Glide(`${this.rootSelector} .reviews_list`,
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'slider',
          // autoplay: 3000,
          animationDuration: 1000,
          gap: 30,
          perView: this.perView(this.hasRating ? 4 : 5), // 1440+
          // focusAt:0 прибивает слайды к левому краю, иначе первый слайд выравнивается по центру
          // страницы образуя слева от себя пустоту
          focusAt: 0,
          bound: true, // эта опция избавляет от пустого места справа
          breakpoints: {
            668: {
              perView: 1,
              gap: 10,
              peek: 20
            },
            1023: {
              perView: this.perView(this.hasRating ? 1 : 2),
              peek: {
                before: 0,
                after: 50
              }
            },
            1439: { perView: this.perView(this.hasRating ? 2 : 4) }
          }
        }
      )
    ).mount({ Swipe, Controls, Autoplay, Breakpoints, Lazy })
  }

  static get modalRoot () {
    return document.getElementById('modal-root')
  }

  static showFullReview (reviewEl) {
    const body = reviewEl.querySelector('.body')
    ReactDOM.render(
      <ModalAlert
        body={<div dangerouslySetInnerHTML={{ __html: body.innerHTML }} />}
        isOpen={true}
        onClose={() => {
          // Let Reveal finish his work
          setTimeout(() => ReactDOM.unmountComponentAtNode(this.modalRoot), 100)
        }}
      />,
      this.modalRoot
    )
  }

  static processReviews () {
    document.querySelectorAll(`${this.rootSelector} .reviews_list .review`).forEach(reviewEl => {
      const contentEl = reviewEl.querySelector('.content')
      const bodyEl = reviewEl.querySelector('.body')
      const readMoreButton = reviewEl.querySelector('.read_more')
      if (contentEl.scrollHeight < bodyEl.scrollHeight) {
        reviewEl.classList.add('has_more')
        readMoreButton.addEventListener('click', () => this.showFullReview(reviewEl))
      } else {
        reviewEl.classList.remove('has_more')
      }
    })
  }

  static mount () {
    if (this.mounted) return
    this.mounted = true

    this.mountGlide()
    this.processReviews()
  }

  static init () {
    this.rootSelector = '.reviews_and_rating'
    lozad(this.rootSelector, { load: this.mount.bind(this) }).observe()
  }
}
